import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import PinImg from 'src/assets/img/house/fix_pin.svg'
import 'src/pages/main/house/drag.css'

export const HouseItemCard = ({
  item,
  onItemSelect,
  selectedItemId,
  isDisabled,
  onBackgroundSelect,
  onConceptSelect,
  onPlaceGhost
}) => {
  const isBackground = item.category === 'background'
  const isConcept = item.category === 'concept'

  const selectedClass = useMemo(() => {
    if (selectedItemId === item.id && !item.pinned) return 'bg-yellow-100 border-cyan-400'
    if (item.pinned) return 'border-stone-gray'
    return 'bg-white border-stone-gray'
  }, [selectedItemId, item.id, item.pinned])

  const cursorClass = useMemo(() => {
    if (isDisabled) return 'cursor-not-allowed opacity-50'
    if (item.pinned) return 'cursor-default'
    return 'cursor-pointer'
  }, [isDisabled, item.pinned])

  const handlePress = () => {
    if (isDisabled || item.pinned) return
    onItemSelect(item.id)
    if (isBackground && onBackgroundSelect) {
      onBackgroundSelect(item)
    } else if (isConcept && onConceptSelect) {
      onConceptSelect(item)
    } else if (onPlaceGhost) {
      onPlaceGhost(item)
    }
  }

  return (
    <div
      onClick={handlePress}
      className={`ios-media-guard bg-pat02 relative border-2 rounded-md p-1 min-h-[80px] flex flex-col items-center justify-center hover:shadow-md transition-all ${selectedClass} ${cursorClass}`}
      style={{ backgroundColor: item.pinned ? '#D1D1D1' : undefined }}
    >
      <div className="w-full h-full relative z-20">
        <div className="mb-1 flex items-center justify-center flex-1">
          <img
            src={item.icon_url}
            alt={item.name || 'Item'}
            className="w-16 h-16 object-cover pointer-events-none"
            draggable={false}
          />
        </div>
        <div className="flex w-full justify-end">
          {!item.pinned && item.amount !== undefined && item.attached_amount > 0 && (
            <div className="bg-white rounded-full w-fit px-1 py-0.5 text-[7px] xs:text-[10px] font-bold text-gray-800 border border-gray-300">
              {`${item.attached_amount}/${item.amount}`}
            </div>
          )}
          {item.pinned && (
            <div className="w-4 xs:w-6 flex items-center justify-center z-30">
              <img src={PinImg} alt="Pin" className="w-full h-full" />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

HouseItemCard.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string,
    icon_url: PropTypes.string.isRequired,
    pinned: PropTypes.bool,
    amount: PropTypes.number,
    attached_amount: PropTypes.number,
    category: PropTypes.string
  }).isRequired,
  onItemSelect: PropTypes.func.isRequired,
  selectedItemId: PropTypes.number,
  isDisabled: PropTypes.bool,
  onBackgroundSelect: PropTypes.func,
  onConceptSelect: PropTypes.func,
  onPlaceGhost: PropTypes.func
}
